import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min.js"
import Header from './Components/Header';
import Footer from './Components/Footer';
import { LanguageProvider } from "./context/LanguageContext";
import { HelmetProvider } from "react-helmet-async";
import React, { Suspense, lazy } from "react";

//  Lazy Load pages
const Home = lazy(() => import("./Pages/Home"));
const About = lazy(() => import("./Pages/About"));
const Services = lazy(() => import("./Pages/Services"));
const Stories = lazy(() => import("./Pages/Stories"));
const ContactUs = lazy(() => import("./Pages/ContactUs"));
const Login = lazy(() => import("./Pages/Login"));
const ForgotPassword = lazy(() => import("./Pages/ForgotPassword"));
const Register = lazy(() => import("./Pages/Register"));
const Terms = lazy(() => import("./Pages/Terms"));



function App() {
  return (
    <LanguageProvider>
      <HelmetProvider>
        <div className="App">
          <Router>
            <Header />
            <Suspense fallback={<div className="text-center py-5">Loading...</div>}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/stories" element={<Stories />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/register" element={<Register />} />
                 <Route path="/term" element={<Terms />} />
                <Route path="*" element={<h2 className="text-center">404 - Not Found</h2>} />
              </Routes>
            </Suspense>
            <Footer />
          </Router>
        </div>
      </HelmetProvider>
    </LanguageProvider>

  );
}


export default App;
